export default {
  SOURCE_PAGE: 'source_page',
  USER_PROFILE: {
    VIEWING_OWN_PROFILE: 'viewing_own_profile',
  },
  NEW_FEATURE_SLUG: 'new_feature_slug',
  MODAL_TYPES: {
    COPY_TO_ASANA: 'Copy to Asana',
    ADD_TO_GOAL: 'Add To Goal',
  },
  ADMIN_DASH_FILTER_TYPES: {
    DEPARTMENT: 'Department',
    DATE_RANGE: 'Date Range',
  },
  INVITE_METHOD_TYPES: {
    CREATE_UPDATE_GOAL: 'Create/update goal',
    INVITE_TEAMMATE_TO_ONE_ON_ONE: 'Invite teammate to existing 1:1 workspace',
    CREATE_GROUP_WORKSPACE_MODAL: 'Create group workspace modal',
    CREATE_ONE_ON_ONE_WORKSPACE_MODAL: 'Create 1:1 workspace modal',
    INVITE_TEAMMATE_NAVIGATION: 'Invite teammates from navigation button',
    INVITE_TO_EXISTING_GROUP_WORKSPACE: 'Invite collaborators to existing group workspace',
    INVITE_FROM_USER_MANAGEMENT: 'Invite teammate from user management table',
    INVITE_FROM_CALENDAR_INTEGRATION: 'Invite from calendar integration flow',
    INVITE_FROM_CALENDAR_WIDGET: 'Invite from calendar widget',
    INVITE_FROM_REIVEW_CYCLE_ADMIN: 'Invite from review cycle admin page',
  },
  QUICK_START_GUIDE: {
    CLICKED_QUICK_START_GUIDE: 'Clicked Quick Start Guide',
    CLICKED_QUICK_START_GUIDE_ITEM: 'Clicked Quick Start Guide Item',
    CLICKED_QUICK_START_GUIDE_CTA: 'Clicked Quick Start Guide Step CTA',
    COMPLETED_QUICK_START_GUIDE_ITEM: 'Completed Quick Start Guide Item',
    ITEM: 'item',
    ACTION: 'action',
    STATUS: 'status',
    IS_QUICK_START_GUIDE_OPEN: 'is QSG open',
    CLICKED_DISMISS: 'Dismissed Quick Start Guide',
  },
  REVISIT_DISCUSSION_TOPIC_EVENTS: {
    OPENED_REVISIT_DROPDOWN: 'Opened Revisit Discussion Topic Dropdown',
    OPENED_REVISIT_CUSTOM_MODAL: 'Opened Revisit Discussion Topic Custom Modal',
    OPENED_REVISIT_SNOOZE_MODAL: 'Opened Revisit Discussion Topic Snooze Modal',
  },
};
